module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.project !== null) ? _c('div', {
    staticClass: "project-detail"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.project.title))])]), _vm._v(" "), _c('p', [_vm._v("Project ID " + _vm._s(_vm.id))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.project.recipient))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "project-message"
    }
  }, [_vm._v(_vm._s(_vm.project.message))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.project.created))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-49a97900"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectDetail.vue
// module id = 128
// module chunks = 1